import { render, staticRenderFns } from "./coin_overview_modal.vue?vue&type=template&id=2a78c4b3&"
import script from "./coin_overview_modal.vue?vue&type=script&lang=js&"
export * from "./coin_overview_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports